// @flow

import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { colors } from '../../style'

import ViewIcon from './ViewIcon'

const Root = styled.div`
  flex: 1;

  position: relative;
  z-index: 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: -2px;

  border: 2px solid black;

  cursor: pointer;

  &:hover {
    z-index: 3;
    color: ${colors.red};
    border-color: ${colors.red};
  }
`

const Icon = styled(ViewIcon)`
  margin-bottom: 12px;
`

type Props = {
  onClick: Function
}

type State = {
  hovered: boolean
}

class ViewButton extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      hovered: false
    };
  }

  render() {
    return (
      <Root
        onMouseEnter={() => { this.setState({ hovered: true }) }}
        onMouseLeave={() => { this.setState({ hovered: false }) }}
        onClick={this.props.onClick}
      >
        <Icon
          width="62"
          height="33"
          hovered={this.state.hovered}
        />
        <FormattedMessage id="book.controls.view" />
      </Root>
    )
  }
}

export default ViewButton



// WEBPACK FOOTER //
// ./src/components/Book/ViewButton.js